import React from 'react';
import {useTranslation} from "react-i18next";

import {useDeleteStation, useUpdateStation} from "../../query";
import useStationForm from "../../stationForm/useStationForm";
import IdentificationSection from "../../stationForm/IdentificationSection";
import MeasurementTypesSection from "../../stationForm/MeasurementTypesSection";
import ActivityPeriodSection from "../../stationForm/ActivityPeriodSection";
import NotesSection from "../../stationForm/NotesSection";
import LocationSection from "../../stationForm/LocationSection";
import MDLoadingButton from "../../../../components/MDLoadingButton";

import MDButton from "materialDashboard/components/MDButton";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import MDDeleteButton from "../../../../components/MDDeleteButton";
import useResourceAuthorization from "../../../auth/useResourceAuthorization";


const PanelInfo = ({station}) => {
    const {t} = useTranslation(['stations']);
    const updateStation = useUpdateStation(station.id);
    const deleteStation = useDeleteStation(station.id);

    const authorization = useResourceAuthorization(station);

    const handleSubmit = async (data) => {
        await updateStation.mutateAsync(data);
    }

    const handleDelete = async () => {
        await deleteStation.mutateAsync();
    }

    const {formik, handlePositionChange} = useStationForm({station, onSubmit: handleSubmit});

    // Disable submit when the nothing is changed or the stationForm has been submitted and it is invalid
    const submitDisabled = !authorization.update || !formik.dirty || (formik.submitCount > 0 && !formik.isValid);

    return <Card>
        <Grid container sx={{p: 3}} columnSpacing={6} rowSpacing={6}>
            <Grid item xs={12} xl={5}>
                <Grid container rowSpacing={6}>
                    <Grid item xs={12}>
                        <IdentificationSection formik={formik} station={station}/>
                    </Grid>

                    <Grid item xs={12}>
                        <MeasurementTypesSection formik={formik}/>
                    </Grid>
                    <Grid item xs={12}>
                        <ActivityPeriodSection formik={formik} station={station}/>
                    </Grid>
                    <Grid item xs={12}>
                        <NotesSection formik={formik}/>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} xl={7}>
                <Grid container rowSpacing={6}>
                    <Grid item xs={12}>
                        <LocationSection formik={formik} onPositionChange={handlePositionChange} station={station}/>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} lg={12} sx={{display: "flex", justifyContent: "space-between"}}>
                <MDDeleteButton onDelete={handleDelete}
                                disabled={!authorization.delete}
                                dialogTitle={t('station.deleteDialog.title')}
                                dialogMessage={t('station.deleteDialog.message')}/>
                <Stack direction="row" spacing={2}>
                    <MDButton color="info" variant="text"
                              onClick={() => formik.resetForm()}
                              disabled={!formik.dirty}>
                        {t('station.panelInfo.cancel')}
                    </MDButton>
                    <MDLoadingButton variant="gradient" color="info" onClick={formik.handleSubmit}
                                     disabled={submitDisabled}
                                     loading={formik.isSubmitting}>
                        {t('station.panelInfo.submit')}
                    </MDLoadingButton>
                </Stack>
            </Grid>
        </Grid>
    </Card>
}

export default PanelInfo;